import Bloc from './Bloc.js';
import Types from './Types.js';
import Library from '../../utility/Library';

export default class FilterProperty extends Bloc {

	constructor (src, ctx) {

		super("filterproperty", src, ctx);
		this.f = (src, ins) => {

			var cardfilter = target => target.getProperty(ins[0]);
			var modelfilter = target => Library.hasSubtype(target, ins[0]) || target[ins[0]];
			
			return [cardfilter, modelfilter];
		};
		this.types = [Types.property];
	}
}
